/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type WorkstreamReadinessAttentionAdminSendRequest = {
    audience: WorkstreamReadinessAttentionAdminSendRequest.audience;
    send_email?: boolean;
    send_slack?: boolean;
};

export namespace WorkstreamReadinessAttentionAdminSendRequest {

    export enum audience {
        MYSELF = 'myself',
        ADMINS = 'admins',
    }


}

